
  <div class="alert alert-success" *ngIf="alertSuccess">
      Admin added successfully!
    </div>
    <div class="alert alert-danger" *ngIf="alertFailure">
       {{errorMsg}} !
    </div>
    <div class="alert alert-success" *ngIf="deleteSuccess">
      Admin deleted successfully!
    </div>
    <div class="alert alert-danger" *ngIf="noUser">
      No user found !
    </div>
    <div class="alert alert-success" *ngIf="userFound">
      Please select from user dropdown
      </div>
    <div class="alert alert-danger" *ngIf="alertError">
     Something went wrong !!!
    </div>
    <div class="alert alert-danger" *ngIf="timeOutError">
      {{timeoutErrorMessage}}
    </div>	

<div class="col-sm-12 col-md-12 col-xl-12">
  <div class="adminTitle">Admin Management</div>

  <br><br>

      
  <form (ngSubmit)="onSubmit()" name="form" #myForm="ngForm">
    <div class="mainSection">     
      <label for="select-users" class="searchlabel">Select Users <span class="star"> *</span></label><span class="colon">:</span>
      <div class="selectDropSet">
          <ng-select id="select-users" placeholder="Select User" name="userName" class="custom" [items]="userList"  bindLabel="userFirstName" 
              bindValue="userId" [(ngModel)]="userFirstName" (change)="userSelection($event)" (keyup)="findbyEmail($event)" 
              required>
              <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div>{{item.userFirstName}}</div>
                  <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
                  <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
              </ng-template>  
          </ng-select> 
      </div>
      
      <label class="searchlabel" for="name">Name</label><span class="colon">:</span><span id="name" class="datas">{{name}}</span>

      <div>
        <label class="searchlabel" for="emailId">Email Id</label><span class="colon">:</span><span id="email" class="datas">{{email}}</span>
      </div>
      <div>
        <label class="searchlabel" for="workdayId">Workday Id</label><span  class="colon">:</span><span id="workdayId" class="datas">{{workId}}</span>
      </div>
   
      <div>
        <label class="searchlabel" for="userRole">User Role</label><span class="colon">:</span><span id="userRole" class="datas">{{roleName}}</span>
      </div>
    </div>
    <div class="btn-div">
      <button type="submit" class="btn btn-danger"  [disabled]="!myForm.valid" data-toggle="modal" data-target="#myModal">ADD</button>
      <button type="button" class="btn btn-danger" (click)="resetClick()" data-toggle="modal" data-target="#myModal">RESET</button>
    </div>

  </form>
<br>
<app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>


  <div class="outer-div">
    <div class="searchBox">
      <label for="search">Search</label>
      <input type="text" class="form-control" id="search" maxlength="50" placeholder="Search by name"
        [(ngModel)]="searchKey" (keyup.enter)="searchMe()">
    </div>
</div>

<p class="text-center" *ngIf="noDataFound"> No data found </p>
<div id="tabledemo1"  *ngIf="tableShow">
<div class="table-container">
  <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
    <thead>
      <tr class="tr-th">
        <th scope="col" (click)="sortMe('user_first_name')" class = "name">Name <span class="sortupdown"><i id="user_first_name1"
          class="fa fa-sort-up"></i><i id="user_first_name2" class="fa fa-sort-down"></i></span></th>
        <th scope="col">User Role</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of adminData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
        <td>{{data.userFirstName}}&nbsp;{{data.userLastName}}</td>
        <td>{{data.adminName}}</td>
        <td>
          <a (click)="delete(data)" class="edit-delete" data-toggle="modal" data-target="#myModal"><img src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
        </td>
      </tr>

    </tbody>
  </table>
</div>

<div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
  <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
  <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
</div>
</div>
</div>
